// extracted by mini-css-extract-plugin
module.exports = {"collectionHeader":"ViewCards_collectionHeader__JT0K1","cardWrapper":"ViewCards_cardWrapper__3IsG2","viewCards":"ViewCards_viewCards__3bcR-"};